import type * as QuestionnaireApiModels from '@/typings/questionnaires-api-models';

const getLinkedListKeys = ({
  fieldTemplate,
  fieldsById,
}: {
  fieldTemplate: Pick<QuestionnaireApiModels.FieldTemplate, 'key' | 'type'> & {
    linkedFields: Array<Pick<QuestionnaireApiModels.LinkedField, 'linkedFieldTemplateId'>>;
  };
  fieldsById: Record<string, Pick<QuestionnaireApiModels.FieldTemplate, 'key' | 'type'>>;
}): string[] => {
  const linkedListKeys = [fieldTemplate.key];

  // Add keys of all lists linked to this fieldTemplate
  if (fieldTemplate.type === 'list' && fieldTemplate.linkedFields) {
    fieldTemplate.linkedFields.forEach((linkedField) => {
      const linkedFieldTemplate = fieldsById[linkedField.linkedFieldTemplateId];
      if (linkedFieldTemplate && linkedFieldTemplate.type === 'list') {
        linkedListKeys.push(linkedFieldTemplate.key);
      }
    });
  }
  return Array.from(new Set(linkedListKeys));
};

export default getLinkedListKeys;
